export default class LeagueStanding {
  rank: number;
  leagueId: number;
  leagueName: string;
  userId: string;
  teamName: string;
  isPrivate: boolean;
  brandId: number;
  isOfficial: boolean;
  isFirestone: boolean;
  isAdmin: boolean;
  isPermanent: boolean;

  constructor(starter: any = {}) {
    this.rank = starter.rank || null;
    this.leagueId = starter.leagueId || null;
    this.leagueName = starter.leagueName || null;
    this.userId = starter.userId || null;
    this.teamName = starter.teamName || null;
    this.isPrivate = starter.isPrivate ? true : false;
    this.brandId = starter.brandId || 0;
    this.isOfficial = starter.isOfficial ? true : false;
    this.isFirestone = starter.isFirestone ? true : false;
    this.isAdmin = starter.isAdmin ? true : false;
    this.isPermanent = starter.isPermanent ? true : false;
  }
}
